export default "__VITE_ASSET__EI2HA1QOBUuBufLZEawAnA__"